import { defineStore } from 'pinia';
import { queryTotalBuyerCartList } from '@/api/buyCar';
import { getStorageSync, setStorageSync } from '@/utils/storage.js';

export const useCartStore = defineStore('cart', () => {
	// State - 保持与 DC 项目相同的变量名
	const cartCount = ref<number | string>(0);

	// Action - 更新购物车数量
	const updateCartCount = async () => {
		const isLogin = import.meta.client && !!getStorageSync('cmdc_access_token_mobile');

		if (!isLogin) {
			cartCount.value = 0;
			return 0;
		}

		const params = {
			pageStart: 1,
			pageSize: 50,
			pageNumber: 1,
			productName: '',
			materialCode: '',
			manufacturer: '',
			licenseCode: '',
			filialeCode: '',
		};

		try {
			const response = await queryTotalBuyerCartList(params);
			const count = response.data?.total > 99 ? '99+' : response.data?.total || 0;
			cartCount.value = count;

			if (import.meta.client) {
				setStorageSync('cartCount', String(count));
			}

			return count;
		} catch (error) {
			console.error('获取购物车数量失败:', error);
			cartCount.value = 0;

			if (import.meta.client) {
				setStorageSync('cartCount', '0');
			}

			return 0;
		}
	};

	// Action - 设置购物车数量
	const setCartCount = (count: number | string) => {
		cartCount.value = count;
		if (import.meta.client) {
			setStorageSync('cartCount', String(count));
		}
	};

	return {
		// State
		cartCount,
		// Actions
		updateCartCount,
		setCartCount,
	};
});
